import type { CSSProperties } from "react";

/**
 * Dark marketing palette shared by the public, unauthenticated pages
 * (`/`, `/pricing`, `/changelog`, `/roadmap`). Mirrors the tokens HomePage
 * applies inline so every marketing surface renders identically regardless of
 * the visitor's app theme preference.
 */
export const marketingThemeStyle = {
  "--background": "228 20% 7%",
  "--surface-1": "226 16% 10%",
  "--surface-2": "224 13% 14%",
  "--surface-3": "222 12% 18%",
  "--foreground": "40 20% 96%",
  "--card": "226 16% 10%",
  "--card-foreground": "40 20% 96%",
  "--muted": "224 12% 16%",
  "--muted-foreground": "224 10% 67%",
  "--primary": "214 88% 64%",
  "--primary-foreground": "222 47% 11%",
  "--border": "223 17% 23%",
  "--success": "148 55% 47%",
  "--warning": "38 92% 54%",
  "--destructive": "0 74% 57%",
} as CSSProperties;
